export const selectPlanet = (state) => state.planet;
